module.exports = __webpack_public_path__ + "static/img/32-翠湖小学(白水洼校区).2de2301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/32-翠湖小学(白水洼校区).png
// module id = gG1z
// module chunks = 0